<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="loanDetails">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลการโอนเงิน</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right" class="mr-1" @click="onPressedCalculate()" v-if="visibilityCalculateButton">ประมวณผล</vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="openLoanDetailModal">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่โอนเงิน</vs-th>
              <vs-th>ประเภท</vs-th>
              <vs-th>จำนวนเงินที่โอน</vs-th>
              <vs-th class="col-approved">สถานะประมวลผล</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td class="text-center">{{ data.length - index }}</vs-td>
                <vs-td class="text-center">{{ row.loanDate }}</vs-td>
                <vs-td class="text-center">{{ row.loanDetailTypeName }}</vs-td>
                <vs-td class="text-right">{{ row.amount | numberFormat }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.processed ? 'success' : 'warning'">{{ row.processed ? 'ประมวลผลแล้ว' : 'รอประมวลผล' }}</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full ml-auto flex sm:justify-end items-center gap-2">

                    <vx-tooltip text="เรียกดูใบเสร็จ" v-if="row.loanDetailReceiptId">
                      <vs-button
                        color="success"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-file-text"
                        @click="onPressedViewReceipt(row.loanDetailReceiptId)">
                      </vs-button>
                    </vx-tooltip>

                    <vx-tooltip text="ลบข้อมูลการโอนเงิน" v-if="!row.processed">
                      <vs-button
                        color="danger"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click="onPressedDelLoanDetail(row.id)">
                      </vs-button>
                    </vx-tooltip>

                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup :active.sync="loanDetailModal.active" title="เพิ่มข้อมูลการโอนเงิน" class="custom-popup">
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="loanDetailForm">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }">
                  <label class="text-sm">วันที่*</label>
                  <flat-pickr :config="configLoanDate" class="w-full" v-model="loanDetailModal.loanDate"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }">
                  <label class="text-sm">จำนวน*</label>
                  <vs-input type="number" class="w-full" v-model="loanDetailModal.amount"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="ประเภท" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">ประเภท*</label>
                  <v-select v-model="loanDetailModal.loanDetailType" :clearable="false" :options="loanDetailTypesOptions" :reduce="res => res.value" name="loanDetailType" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="หมายเหตุ" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">หมายเหตุ*</label>
                  <vs-textarea v-model="loanDetailModal.remark" rows="5"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptLoanDetailModal">บันทึก</vs-button>
        <vs-button color="danger" @click="loanDetailModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import moment from "moment/moment";
import { Thai } from "flatpickr/dist/l10n/th";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { ILoanDetailType } from "@/constants/interface";

const { mapActions: mapAccountingActions, mapState: mapAccountingFields } = createNamespacedHelpers('Accounting');

export default {
  name: 'LoanDetailTab',
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      loanDetailModal: {
        active: false,
        loanDate: moment().format('DD-MM-YYYY'),
        loanDetailType: ILoanDetailType.tuitionFee,
        amount: 0,
        remark: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      loanDetailTypesOptions: 'Master/loanDetailTypesOptions',
    }),
    ...mapAccountingFields(['contractDetail', 'contractDetailLoanDetails']),
    configLoanDate() {
      let minDate = null;
      if (this.contractDetail && this.contractDetail.contractLoanDate) {
        minDate = moment(this.contractDetail.contractLoanDate).add(1, 'days').format('DD-MM-YYYY');
      }

      return {
        monthSelectorType: 'static',
        allowInput: true,
        locale: Thai,
        dateFormat: 'd-m-Y',
        minDate,
      }
    },
    loanDetails() {
      if (!this.contractDetailLoanDetails) return [];
      return [...this.contractDetailLoanDetails]
        .sort((a, b) => new Date(b.loanDate) - new Date(a.loanDate));
    },
    visibilityCalculateButton() {
      if (!this.contractDetailLoanDetails) return false;
      const unProcessLoanDetails = this.contractDetailLoanDetails.filter(({ processed }) => !processed);
      return unProcessLoanDetails.length > 0;
    },
  },
  methods: {
    ...mapAccountingActions([
      'calculateContractDetailPayment',
      'createContractDetailLoanDetail',
      'deleteContractDetailLoanDetail',
    ]),
    resetLoanDetailModal() {
      this.loanDetailModal.active = false;
      this.loanDetailModal.loanDate = moment().format('DD-MM-YYYY');
      this.loanDetailModal.loanDetailType = ILoanDetailType.tuitionFee;
      this.loanDetailModal.amount = 0;
      this.loanDetailModal.remark = '';
    },
    openLoanDetailModal() {
      this.resetLoanDetailModal();
      this.loanDetailModal.active = true;
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
    getPathLoanDetailReceipt(id) {
      return `${process.env.VUE_APP_REPORT_SERVER}/pdf/loanDetailReceipt?id=${id}&version=v.1.0.0`;
    },
    onPressedViewReceipt(id) {
      this.openUrl(this.getPathLoanDetailReceipt(id));
    },
    async onPressedAcceptLoanDetailModal() {
      const { id: contractId } = this.$route.params;
      this.$refs['loanDetailForm'].validate().then(async success => {
        if (!success) {
          return;
        }

        const loanDate = this.$options.filters.convDDMMYYYYToYYYYMMDD(this.loanDetailModal.loanDate.trim());
        await this.createContractDetailLoanDetail({
          contractId,
          form: {
            loanDate,
            loanDetailType: this.loanDetailModal.loanDetailType,
            amount: parseFloat(this.loanDetailModal.amount),
            remark: this.loanDetailModal.remark,
          }
        })

        this.resetLoanDetailModal();
      })
    },
    async onPressedCalculate() {
      const { id: contractId } = this.$route.params;
      const { calculateContractDetailPayment } = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการประมวลผล',
        text: 'คุณต้องการประมวลผลข้อมูลการโอนเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await calculateContractDetailPayment({ contractId })
        }
      })
    },
    async onPressedDelLoanDetail(id) {
      const { id: contractId } = this.$route.params;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูลการโอนเงิน',
        text: 'คุณต้องการลบข้อมูลการโอนเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await this.deleteContractDetailLoanDetail({ id, contractId })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-actions {
  width: 100px;
}

.col-approved {
  width: 130px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
